import {Component, OnInit} from '@angular/core';
import {NgbAccordionModule, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-faqs',
  imports: [
    NgbAccordionModule,
    TranslatePipe
],
  templateUrl: './faqs.component.html',
})
export class FaqsComponent implements OnInit{
  faqs: any[] = [];

  constructor(private readonly translate: TranslateService, public activeModal: NgbActiveModal) {
    this.translate.get('faq').subscribe((data: any[]) => {
      this.faqs = data;
    });
  }

  ngOnInit() {
    this.translate.get('FAQS.ITEMS').subscribe((items: any[]) => {
      this.faqs = items;
    });
  }
}
